import { render, staticRenderFns } from "./tap-vip-customer.vue?vue&type=template&id=8d1fedf2"
import script from "./tap-vip-customer.vue?vue&type=script&lang=js"
export * from "./tap-vip-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports